
import React, { Component } from "react";
import {  Link } from "react-router-dom"
import SojTerrainLocationSVPriceListView from '../../sojterrain/SojTerrainLocationSVPriceListView'
   
import {SV_SOJ_ORCMOCK_ADDRESS, SV_SOJ_NOTCAROUSEL_VIEW} from '../../../constants'

import InfiniteScroll from "react-infinite-scroll-component";
import moment from 'moment'
import SJCarousel from "../../../views/SJCarousel";
import SJCarouselDyna from "../../../views/SJCarouselDyna";
const style = {
  height: 30,
  border: "1px solid green",
  margin: 6,
  padding: 8
};


class InvSJScroll extends Component {

    state = {
        items: Array.from({ length: 5 }),
        hasMore: true
      };
     

      getCarouselOrPhoto = (o) =>{
         let ar =  o['imgs']
        let roomImgs =ar
        let roomImg = `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`
        if(roomImgs && (roomImgs.length > 0)) {
             roomImg = roomImgs[0]
        }

        let photoOnly =  SV_SOJ_NOTCAROUSEL_VIEW ? SV_SOJ_NOTCAROUSEL_VIEW :false
        
        if(photoOnly){
                      return  (
                  <div className="gallery">
                      <figure style={{'marginBottom':'0px'}}>
                      <span  >	<Link to={`/svessearch/svredsojourn/${o.space_key}`}> 
                      
                      <img src={`${roomImg}`}  alt="Carpet Grass" />
                      </Link> </span>
                          
                      </figure>
                  </div>)

        }
        //check ar
        if(ar && (ar.length > 2) ){
            let roomImgs = ar.slice(0,6)
          return ( <SJCarouselDyna roomImgs={roomImgs} ></SJCarouselDyna>)

        }else{
            return ( <SJCarousel ></SJCarousel>)
        }

    }
    
      //render start

      fetchMoreData = () => {
        console.log('SV**JUN13*****SJScroll*******fetchMoreData called')
        const{sv_esquery_data,my_scr_id} = this.props
       
        const {my_esqueryText,STARTDATE,ENDDATE,time_zone} =sv_esquery_data
        let startDate = STARTDATE
        let endDate = ENDDATE
        
        console.log('SJ Jun12InvSJScroll needs *** my_scr_id from reducer ',my_scr_id)
        let start_date_s   = moment(startDate).toISOString() 
    console.log("**formatISO***", start_date_s)

    let esqueryText = my_esqueryText ? my_esqueryText :'MCO' 
    let moEndDate = moment(endDate)
    let moStartDate = moment(startDate)
    let mo_es = moEndDate.format('YYYY-MM-DD') 
    let mo_ss = moStartDate.format('YYYY-MM-DD') 
    let end_date_s   = moment(endDate).toISOString() 
    console.log("**Jun12Y25**end_date_s and sv_esquery_data *", end_date_s)
    console.log(sv_esquery_data)
 if(!my_scr_id){
   console.log('FRAVE ERROR REDUCE SHOULD SUPPY my_scr_id ')
 }
    let sojPostPaginateRqMore= {
        "svfields": [
            "images",
            "sojourn_name",
            "address",
           
            "code",
            "sojournGeocode",
            "categoryCode",
            "categoryGroupCode",
            "accommodationTypeCode",
    
            "sojourn_city",
            "countryCode",
            "stateCode",
            "postalCode",
             "countryCode",
             "ranking",
             "web",
             "terminals",
            "destinationCode"
        ],
        "dates": {
            "STARTDATE_ITN_TZAWARE_EST": (mo_ss ? mo_ss: "2025-10-24" ),
            "ENDDATE_ITN_TZAWARE_EST": (mo_es ? mo_es: "2025-10-27" ),
            "DT_FORMAT": "%Y-%m-%d",
            "time_zone": "Asia/Kolkata",
            "OP": "range"
        },
        "facets": {
            "accommodationTypeCode": "H"
        },
        "useCity": false,
        "dst": esqueryText ? esqueryText : "BEVERLY HILLS",
    
        "esqueryChilds": "m0",
        "esqueryInfants": "i0",
        "esqueryAdults": "t1",
        "esqueryCabin": "ECONOMY",
        "esqueryTripType": "roundtrip",
        "svpageSize": 5,
        "codeKeys": [
               
            ],
        "destinationCode": esqueryText ? esqueryText : "BEVERLY HILLS",
        "esqueryRooms": "r1",

        "pagenumber":1,
        "my_scr_id": my_scr_id ? my_scr_id : ''
    }
     
       console.log('sojPostPaginateRqMore',sojPostPaginateRqMore)

        if (this.state.items.length >= 500) {
          this.setState({ hasMore: false });
          return;
        }
        // a fake async api call like which sends
        // 20 more records in .5 secs
        /*
          */
        this.props.sojAndImagesSojournMore(sojPostPaginateRqMore, sv_esquery_data)
     
        /*
        setTimeout(() => {
          this.setState({
            items: this.state.items.concat(Array.from({ length: 5 }))
          });
        }, 500);
        */
      };
  render() {
    const {hasMore,my_data, sjofferselectparent, sjhotelselectparent, sjprobatecourtselectparent} = this.props
    let {ctotal} = this.props
    ctotal = ctotal ? ctotal :2
    console.log("SJJun13 InvScroll  ctotal JUL13*****************",ctotal);
    console.log(this.props)
    console.log("SJJun13 InvScroll  hasMore*****************",hasMore);
    let ndata = my_data ? my_data.length : -1
    console.log("SJJun13 InvScroll  my_data.length*****************",ndata);

           
    return (
      <div className="main-listhotels">
          {/* 
            <h1>demo: invSJScroll Jun12 react-infinite-scroll-component</h1>
        <hr />
          */}
      
        {/*  
         <InfiniteScroll
          dataLength={my_data.length}
          next={this.fetchMoreData}
          hasMore={hasMore}
          loader={<h4>Loading...</h4>}
          endMessage={
            <div style={{ textAlign: "center" }}>
              <b>Yay! You have seen it all</b>
            </div>
          }
        >
        */}
        <InfiniteScroll
          dataLength={ctotal}
          next={this.fetchMoreData}
          hasMore={hasMore}
          loader={<h4>Loading...</h4>}
          endMessage={
            <div style={{ textAlign: "center" }}>
              <b>Yay! You have seen it all</b>
            </div>
          }
        >
        
        <article style={{backgroundColor: "#fff"}} >
           {
                   my_data.map((o,index) => {
                       let soj = o
                       //convet keys of o to uppercase
                       console.log('sv***soj**')
                       console.log(soj)
                       let assets_ob = soj["assets"]
           if( assets_ob &&  assets_ob.length > 0){
               soj['roomMeta']  = assets_ob[0]["name"]
               soj['roomsAvailable'] = assets_ob.length
           }else{
               soj['roomMeta']  = "2 SVQueen Bed"
               soj['roomsAvailable']  = 0
           }
                       let roomImgs = soj['imgs']
                       let roomImg = `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`
                       if(roomImgs && (roomImgs.length > 0)) {
                            roomImg = roomImgs[0]
                       }
                       
                       console.log('sv888MAY6888IMGS', roomImg);
                       if(!(soj["hotel"])){
                           return (
                               <div>FeetPage</div>
                           )
                       }
                       let terminals = soj["hotel"]['terminals']
                       let categoryCode =soj["hotel"]['categoryCode']
                       let terminalOld = {"terminalCode": "MLS", "distance":87}
                       let terminal = null
                       let sojStar = 1
                       if(categoryCode && (categoryCode.length > 0) ){
                        sojStar = parseInt(categoryCode.substr(0,1)) 
                       }
                       if(terminals && (terminals.length > 0)) {
                            terminal = terminals[0]
                       }
                       //sv room

                       let rooms = soj["hotel"]['rooms']
                       
                       let room = null
                       let roomConent  =''
                       if(rooms && (rooms.length > 0)) {
                            room = rooms[0]
                            let { roomStays} = room
                            if (roomStays){
                               roomStays.forEach( stay => {
                                   roomConent = roomConent + `${stay.order} ${stay.stayType}`

                               })
                            }
                            roomConent = `${roomConent} - ${room.roomType}` 
                       }else{
                           o.bedroomcode = o.bedroomcode ? o.bedroomcode : "2"
                           roomConent = `${o.bedroomcode} SVQueen Beds`
                           
                       }
                       soj["roomConent"] = roomConent
                       soj["sojStar"] = sojStar

                       //let terminalContent = `${terminal.distance} miles from ${terminal.terminalCode}`
                       
                       console.log('sv888MAY6888IMGS', roomImg);
                       let customerId = -1
                       let svcustProfile = {
                        "customerId": -6,
                        "addressId":-1
                    }
                       let priceInfo = {
                           o:o,
                          
                           customerId:customerId
                       }
                       let reservekey = 'insvreview'
                       let svr_location = {
                           "space_key": soj['space_key'] ? soj['space_key'] : "203@4@F@10@10@20251124@7@Y@EVR",
                           "resort_name": soj['sojourn_name'] ? soj['sojourn_name'] : "253 Mancreek Resort" ,
                           "address_line1": soj['address_line1'] ? soj['address_line1'] : " 253 scottland av",
                           "county": soj['county'] ? soj['county'] : "albanyt",
                           "city": soj['city'] ? soj['city'] : "albanyt",
                           "postalcode":soj['postal_code'] ? soj['postal_code'] : 12193,
                           "market_code":soj['marketcode'] ? soj['marketcode'] :  "NAMER",
                           "country": soj['country_name'] ? soj['country_name'] : "usa",
                          "nearest_airport_distance_mi_lvl": soj['nearest_airport_distance_mi_lvl']?  soj['nearest_airport_distance_mi_lvl'][0]: 3,
                          "en_nearest_airports_lvl": soj['en_nearest_airports_lvl']?  soj['en_nearest_airports_lvl'][0]: 3,
                           
                          "num_reviews":soj['num_reviews'] ? soj['num_reviews'] : 10,
                          "state":soj['state'] ? soj['state'] : "NY"

                       }
                       
                       if(terminal != null){
                           svr_location["nearest_airport_distance_mi_lvl"] = terminal.distance
                           svr_location["en_nearest_airports_lvl"] = terminal.terminalCode
                       }
                       return (
                        
                       
                     
                        <div  key={index}  className="svr-sojlist-box-row1">
                           <div className="svr-sojlist-boxr-1">
                               {/*  
                                     <div className="gallery">
                                   <figure style={{'marginBottom':'0px'}}>
                                   <span  >	<Link to={`/svessearch/svredsojourn/${o.space_key}`}> 
                                  
                                   <img src={`${roomImg}`}  alt="Carpet Grass" />
                                    </Link> </span>
                                       
                                   </figure>
                               </div>

                               or
                                <SJCarousel ></SJCarousel>
                               */}
                               {this.getCarouselOrPhoto(o)}
                              
                              
                           </div>
                           
           
                           <SojTerrainLocationSVPriceListView sjofferselectparent= {sjofferselectparent}  priceInfo={priceInfo} svcustProfile={svcustProfile} reservekey={reservekey}  svrlocation={svr_location} sjhotelselectparent={sjhotelselectparent} sjprobatecourtselectparent={sjprobatecourtselectparent} ></SojTerrainLocationSVPriceListView>

                       </div>
              
                       )
                   })
               }
              {/* 
               <div className="svr-sojlist-box-row1 svr-sojlist-box-row1-last ">
                   <div className="svr-sojlist-boxr-1">
                       <div className="gallery">
                           <figure style={{width:'360px', height:'200px'}}>
                           <span>	<Link to={`/svredsojourn`} > 
                           
                           <img  style={{width:'320px'}} src={`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`} alt="Carpet Grass" />
                            </Link> </span>
                              
                           </figure>
                       </div>
                   </div>
   
                   <div className="svr-sojlist-boxl-2">
                       <div className="box-outer-listhotels">
                           <div className="box-left-listhotels">
                               <p className="m-para-text-first">
                                   <text className="svr-hotel-name">SV Cambria Hotel Oraland </text>
                                   <span className="ter-l2 svr-hotel-location">Oralndo <text>Shown On map</text> <text>4 iles
                                           away</text></span>
                                  
                               </p>
                           </div>
                           <div className="box-right-listhotels">
                               <p className="m-para-text-first">
                                   <text className="svr-hotel-rating">Excellent </text>
                                   <text className="f12 d-block">12345 reviews </text>
                               </p>
                           </div>
                       </div>
   
   
                       <div className="box-outer-listhotels">
                           <div className="box-left-listhotels">
                               <p className="m-para-text">
                                   <text className="svr-hotel-room"> Standard Queen Room With two Queen Rooms & shower </text>
                                   <text className="f12  d-block"> 2 Queen Beds </text>
                               </p>
                           </div>
                           <div className="box-right-listhotels">
                               <p className="m-para-text">
                                   <text className="svr-hotel-stay">1night, 2days </text>
                                   <text className="svr-hotel-price d-block">$116 </text>
                               </p>
                           </div>
                       </div>
                       
                       <div className="box-outer-listhotels">
                           <div className="box-left-listhotels">
                               <p className="svr-hotel-avail">
                                   <text className="f19"> Only 8 Rooms left </text>
                               </p>
                           </div>
                           <div className="box-right-listhotels">
                               <p>
                             
                               </p>
                           </div>
                       </div>
   
   
                   </div>
   
   
               </div>
              
              */}
              
           </article>
        </InfiniteScroll>
      </div>
    );
  }
      //render end

    
}

export default InvSJScroll;

  /*
    fetchMoreData = () => {
        console.log('sv***fetchMoreData calles SJJun1212Y25')
        console.log(this.props)
        
        // a fake async api call like which sends
        // 20 more records in .5 secs
        
        setTimeout(() => {
          //  this.props.sojAndImagesSojourn()
          
          this.setState({
            items: this.state.items.concat(Array.from({ length: 4 }))
          });
          
        }, 500);
        
      };
*/